import { render, staticRenderFns } from "./RoleSelect.vue?vue&type=template&id=42b360f1&scoped=true&"
import script from "./RoleSelect.vue?vue&type=script&lang=js&"
export * from "./RoleSelect.vue?vue&type=script&lang=js&"
import style0 from "./RoleSelect.vue?vue&type=style&index=0&id=42b360f1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b360f1",
  null
  
)

export default component.exports